/** NEW JS */

window.onload = function () {

  lax.init()

  $("[data-show-reviews], .Product__reviews-stars").on('click', function() {
    $("#netreviewsWidgetNum24432widget02av").click()
  });
  // Add a driver that we use to control our animations
  
  lax.addDriver('scrollY', function () {
    return window.scrollY
  })
  if ($(window).width() > 960) {
  // Add animation bindings to elements
  if ($(window).width() > 1024) {
    var sk = 136;
  } else {
    var sk = 96;
  }  

  if ($(".Product-block-image-cta") && $(".Product-block-image-cta").length > 0) {
  
  var height_block_image_calcul = $(".Product-block-image-cta").height() * -1 + sk;

    if ($(window).width() > 1440) {
      var height_block_image_calcul = $(".Product-block-image-cta").height() * -1 + 90;
      var sk = 160;
    }

    var height_block_image_calcul = ($('.Product-section-info').height() + sk) * -1;

  

    var h = $(".Product-block-image-cta").height();
    var top = $(".Product-block-image-cta").offset().top - $('.Product-section-info').height() - sk * 2;
    var bottom = $(".Product-block-image-cta").offset().top - $('.Product-section-info').height() - $(window).height();

    // Anim panneaux
    lax.addElements('.Product-block-image-cta', {
      scrollY: {
        translateY: [
          [bottom, top],  // Driver value map
          [height_block_image_calcul, 0]
        ]
      }
    });




    // Anim cruci richtext
    if($('.Product-richtext__cruci').length) {
      var top_begin_elem = $('.Product-richtext__cruci').offset().top - 450;
      var top_stop_elem = $('.Product-richtext__cruci').offset().top + 450;
      lax.addElements('.Product-richtext__cruci', {
        scrollY: {
          translateY: [
            [0, top_stop_elem],  // Driver value map
            [-120, 100] 
          ]
        }
      });
    }

    if($('.Produc-text-video__text-container').length) {
      var stop_elem = $('.Produc-text-video__text-container').offset().top - 400;


      // Anim text video
      var stop_elem2 = $('.Produc-text-video__text-container').offset().top + $(window).height() / 6;
      lax.addElements('.Produc-text-video__text-container', {
        scrollY: {
          translateY: [
            [stop_elem, stop_elem2],  // Driver value map
            [200, 0] 
          ]
        }
      });

        // Anim text video
        var stop_elem2 = $('.Produc-text-video__text-container').offset().top + $(window).height() / 6;
        lax.addElements('.Product-text-video__video-padding', {
          scrollY: {
            translateY: [
              [stop_elem, stop_elem2],  // Driver value map
              [-200, 0] 
            ]
          }
        });

        // Anim cruci & video
        var stop_elem = $('.Product-text-video__video-padding').offset().top - 400;
        var stop_elem2 = $('.Product-text-video__video-padding').offset().top + $(".Product-text-video__video-padding").height();

        lax.addElements('.Product-text-video__video', {
          scrollY: {
            translateY: [
              [stop_elem, stop_elem2],  // Driver value map
              [0, -100] 
            ]
          }
        });
      }

      lax.addElements('.video-cruci', {
        scrollY: {
          translateY: [
            [stop_elem, stop_elem2],  // Driver value map
            [0, -100] 
          ]
        }
      });

      
      // Anim cruci reviews
      var stop_elem_reviews = $('.Product-reviews').offset().top - $(window).height();
      lax.addElements('.reviews__cruci', {
        scrollY: {
          translateY: [
            [stop_elem_reviews, 'elOutY'],  // Driver value map
            [-200, -600] 
          ]
        }
      });



      // Anim cruci selector kit
      var stop_elem_selector = $('[data-section-type="kit-selector"]').offset().top - 450;
      lax.addElements('.kit-selector__cruci', {
        scrollY: {
          translateY: [
            [stop_elem_selector, 'elOutY'],  // Driver value map
            [200, -600] 
          ]
        }
      });

    }

 
  } else {

    if ($('.Product-featured-pictures-mobile') && $(".Product-featured-pictures-mobile").length > 0) {
      var splide = new Splide( '.Product-featured-pictures-mobile', {
        type     : 'loop',
        drag: 'free',
        autoWidth: true,
        pagination: false,
        arrows: false
      } );
      
      splide.mount();
    }


    // Anim phone mobile
    if ($('.image-phone-container--mobile') && $('.image-phone-container--mobile').length > 0) {
      var top_begin_elem = $('.image-phone-container--mobile').offset().top + 250;
      var top_stop_elem = $('.product-image-text__slider').offset().top - $(window).height() / 2;
      
      var scroll_y = $('.product-image-text__item--first .product-image-text__content').height() * 0.55;
      lax.addElements('.image-phone-container--mobile', {
        scrollY: {
          translateY: [
            [top_begin_elem, top_begin_elem + 300],  // Driver value map
            [0, scroll_y] 
          ]
        }
      });
    }

  }

  // Product image grid slider

  if ($('.product-image-text__slider') && $('.product-image-text__slider').length > 0) {
    var splide_img_grid = new Splide( '.product-image-text__slider', {
      arrows: 'true',
      type: 'slide',
      pagination: false,
      autoWidth: true,
      arrowPath: 'M19.0804 0.43396L17.3357 2.17864L23.974 8.64673H0.612305V11.1999H24.0591L17.3357 17.7106L19.0804 19.4978L28.6123 9.96588L19.0804 0.43396Z',
      focus  : 'center'
    } );
    
    splide_img_grid.mount();
  }
  

  // Product review slider

  if ($('.Product-reviews') && $('.Product-reviews').length > 0) {
    var splide_reviews = new Splide( '.Product-reviews', {
      arrows: 'true',
      type: 'slide',
      pagination: false,
      autoWidth: true,
      padding: '5rem',
      arrowPath: 'M19.0804 0.43396L17.3357 2.17864L23.974 8.64673H0.612305V11.1999H24.0591L17.3357 17.7106L19.0804 19.4978L28.6123 9.96588L19.0804 0.43396Z',
      focus  : 'center'
    } );
    
    var add_to_cart_review;
    splide_reviews.mount();
    splide_reviews.on( 'move', function (newIndex) {
      if ($('.add-to-cart--review') && $('.add-to-cart--review').length > 0) {
        var new_i = newIndex + 1;
        if ($('#splide01-slide0' + new_i + ' .js-productForm-submit').length > 0) {
          add_to_cart_review = $('#splide01-slide0' + new_i + ' .js-productForm-submit');
          $(".add-to-cart--review").addClass("actif");
        } else {
          $(".add-to-cart--review").removeClass("actif");
        }
      }
    });
    $(".add-to-cart--review").on("click", function() {
      add_to_cart_review.click();
    });
  }
  

  // Anim index product image mobile

  if ($(".index-products__item:first-child") && $(".index-products__item:first-child").length > 0) {
    var elem1 = $(".index-products__item:first-child").offset().top;
    var width_img = $('.index-products__item:first-child img.hidden-lap-and-up').width();
    lax.addElements('.index-products__item:first-child img.hidden-lap-and-up', {
      scrollY: {
        translateX: [
          [elem1 - $(window).height() / 2, elem1 + $(window).height() * 1 ],  // Driver value map
          [$(window).width() * 0.05, $(window).width() * -1] 
        ]
      }
    });
  
    var elem2 = $(".index-products__item:last-child").offset().top;
    var width_img2 = $('.index-products__item:last-child img.hidden-lap-and-up').width();
    lax.addElements('.index-products__item:last-child img.hidden-lap-and-up', { 
      scrollY: {
        translateX: [
          [elem2 - $(window).height() / 2, elem2 + $(window).height() * 1 ],  // Driver value map
          [$(window).width() * 0.05, $(window).width() * -1] 
        ]
      }
    });
  }
  

   /** HOME PAGE ANIM LOGO */

   if ($('.index-products-animation-keys') && $('.index-products-animation-keys').length > 0) {
    var minHeightContainer = $('.index-products-animation-keys').height() + $('.index-products__grid').height() + $('.index-products-animation').height() + 200;
    document.documentElement.style.setProperty('--minHeightIndexContainer', `${minHeightContainer}px`);
 
       
    var start_elem_selector = $('.index-products__container').offset().top - 200;
    if ($(window).width() < 960) {
      start_elem_selector = $('.index-products__item:last-child .index-products__footer').offset().top - 150;
    }
    lax.addElements('.black-cruci', {
      scrollY: {
        scale: [
          [start_elem_selector, start_elem_selector + 150],  // Driver value map
          [1, 0] 
        ]
      }
    });
 
    var start_elem_selector = $('.index-products__container').offset().top - 50;
    var width_black = $('.index-products-animation__icon--center').width() / 2;
    if ($(window).width() < 960) {
     start_elem_selector = $('.index-products__item:last-child .index-products__footer').offset().top - 100;
   }
    lax.addElements('.index-products-animation__icon--center', {
      scrollY: {
        scale: [
          [start_elem_selector, start_elem_selector + 150],  // Driver value map
          [0, 1] 
        ]
      }
    });
 
 
    var start_elem_selector = $('.index-products__container').offset().top + 50;
    if ($(window).width() < 960) {
     start_elem_selector = $('.index-products__item:last-child .index-products__footer').offset().top;
   }
    var left_start = ($(window).width() / 2 + 200) * -1;
    lax.addElements('.index-products-animation__icon--start', {
      scrollY: {
        translateX: [
          [start_elem_selector, start_elem_selector + 250],  // Driver value map
          [left_start, 0] 
        ]
      }
    });
 
    var start_elem_selector = $('.index-products__container').offset().top + 50;
    if ($(window).width() < 960) {
     start_elem_selector = $('.index-products__item:last-child .index-products__footer').offset().top;
   }
    var right_start = $(window).width() / 2 + 200;
    lax.addElements('.index-products-animation__icon--end', {
      scrollY: {
        translateX: [
          [start_elem_selector, start_elem_selector + 250],  // Driver value map
          [right_start, 0] 
        ]
      }
    });
 
    /** Anim cruci richtext homepage */
 
    var start_elem_selector = $('.PT-text__cruci').offset().top;
    if ($(window).width() < 960) {
     start_elem_selector = $('.PT-text__cruci').offset().top;
   }
    lax.addElements('.PT-text__cruci', {
      scrollY: {
        translateY: [
          ['elInY', start_elem_selector + $(window).height()],  // Driver value map
          [0, $(window).height() * -1] 
        ]
      }
    });
   }
}

var in_timeout = false;
var dark_mode = false;
$(window).on('scroll', function() {
  var scroll_top = $(window).scrollTop();

  if ($('.Product-caracteristics') && $('.Product-caracteristics').length > 0) {
    var section_top = $('.Product-caracteristics').offset().top;
    if ($(window).width() > 960) {
      var section_limit_top = $('.Product-caracteristics__thumb').offset().top + 150;
    } else {
      var section_limit_top = $('.Product-caracteristics__Content').offset().top + $('.Product-caracteristics__Content').height();
    }
    if (scroll_top >= section_top - $(window).height() + 336 && scroll_top < section_limit_top) {
      $('body').addClass("dark");
    } else {
      $('body').removeClass("dark");
    }

    var in_timeout = false;
    if ($(window).width() > 960) {

      if (scroll_top > $('.steps-detail').offset().top - $(window).height() / 2 && scroll_top < $(".steps-detail").offset().top + $('.steps-detail').height() - 400) {
        $('body').addClass("yellow");
        $(".Product-background-details").removeClass("to-left").removeClass("to-right").addClass("scrolled");

      } else if (scroll_top > $(".steps-detail").offset().top + $('.steps-detail').height() - 400 && scroll_top < $(".Product-image-text--slider").offset().top - 200) {
        $(".Product-background-details").removeClass("scrolled").addClass("to-left");
        $('body').addClass("yellow");
    
      } else if (scroll_top > $(".Product-image-text.Product-image-text--slider").offset().top - 200 && scroll_top < $(".Product-image-text.Product-image-text--slider").offset().top + 100) {
        $(".Product-background-details").removeClass("to-left").addClass("to-right");
        $('body').removeClass("yellow");
        setTimeout(function() {
          if (in_timeout == false) {
            $(".Product-background-details").removeClass("to-right");
            in_timeout = true;
          }
          in_timeout = false;
        }, 1000);
      } else {
        $(".Product-background-details").removeClass("scrolled").removeClass("to-left").removeClass("to-right");
          $('body').removeClass("yellow");
      }

    } else {
      /*if (scroll_top > $('.steps-detail').offset().top - $(window).height() / 4 && scroll_top < $(".steps-detail__item:nth-child(2)").offset().top - 200) {
        $('body').addClass("yellow");
        $(".Product-background-details").removeClass("to-left").removeClass("to-right").addClass("scrolled");

      } else if (scroll_top > $(".steps-detail__item:nth-child(2)").offset().top - 200 && scroll_top <= $('.product-image-text__image').offset().top - 200) {
        $(".Product-background-details").removeClass("scrolled").removeClass("to-right").addClass("to-left");
        $('body').addClass("yellow");
    
      } else if (scroll_top > $('.product-image-text__image').offset().top - 200 && scroll_top <= $('.product-image-text__grid--left .product-image-text__content-container').offset().top - 150) {
        $(".Product-background-details").removeClass("to-left").removeClass("to-end").addClass("to-right");
        $('body').addClass("yellow");

      } else if (scroll_top > $('.product-image-text__grid--left .product-image-text__content-container').offset().top - 150 && scroll_top <= $('.product-image-text__slider').offset().top - 100) {
        $(".Product-background-details").removeClass("to-right").removeClass("to-left").addClass("to-end");
        $('body').addClass("yellow");
      } else {
        $(".Product-background-details").removeClass("scrolled").removeClass("to-left").removeClass("to-right").removeClass("to-end");
          $('body').removeClass("yellow");
      }*/
    }
  }

  var is_desktop = $(window).width() > 960 ? true : false;
  if ($('.template-index').length > 0) {
    var begin_top = $("#section-163510303291775af0").offset().top - $(window).height() / 4;
    var end_top = $("#section-163510303291775af0").offset().top + $("#section-163510303291775af0").height() - 200;

    if (scroll_top >= begin_top && scroll_top < end_top) {
      $('body').removeClass("yellow").addClass("dark");
      dark_mode = true;
      $(".v2-section-bg").removeClass("scrolled").removeClass("to-end").removeClass("to-left");
    } else if (scroll_top > end_top && scroll_top <= $(".Product-content .Product-image-text:nth-child(2)").offset().top - 300) {
      $('body').removeClass("dark");
      if (is_desktop) {
        $('body').addClass("yellow");
      }
      dark_mode = false;
      $(".v2-section-bg").removeClass("to-left").removeClass("to-end").addClass("scrolled");
      
    } else if (scroll_top > $(".Product-content .Product-image-text:nth-child(2)").offset().top - 300 && scroll_top <= $('.template-index [data-section-type="product-reviews"]').offset().top - 200) {
      $(".v2-section-bg").removeClass("scrolled").removeClass("to-end").addClass("to-left");
      $('body').removeClass("dark");
      if (is_desktop) {
        $('body').addClass("yellow");
      }
      dark_mode = false;
    } else if (scroll_top > $('.template-index [data-section-type="product-reviews"]').offset().top - 200) {
      $(".v2-section-bg").removeClass("scrolled").removeClass("to-left").addClass("to-end");
      $('body').removeClass("dark").removeClass("yellow");
      dark_mode = false;
    } else {
      $('body').removeClass("dark");
    }
  

    if (scroll_top > $('#section-1635108403b82fb0d7').offset().top - 300) {
      $("body").addClass("dark");
    } else {
      if (!dark_mode) {
        $("body").removeClass("dark");
      }
    }
  }
});

$(document).ready(function() {
  if ($('.template-product').length > 0) {
    setTimeout(function() {
      $(".atw-opacity-0.atw-transition-opacity.atw-duration-200.atw-my-1.atw-pl-1.atw-text-xs.atw-font-normal.atw-text-right").remove();
    }, 2000);
    var last_scroll = 0;
    if ($(window).width() > 960) {
      $(document).on('scroll', function() {
        if ($(window).scrollTop() > 0 && !($(window).scrollTop() < 300 && last_scroll > $(window).scrollTop())) {
          $('.Product-background').addClass("scrolled");
          $(".Product-richtext__cruci").addClass("scrolled");
        } else if ($(window).scrollTop() < 300 && last_scroll > $(window).scrollTop()) {
          $('.Product-background').removeClass("scrolled");
          $(".Product-richtext__cruci").removeClass("scrolled");
        } else {
          $('.Product-background').removeClass("scrolled");
          $(".Product-richtext__cruci").removeClass("scrolled");
        }
        if ($(window).scrollTop() > $('.Product').outerHeight(true) - 150) {
          $('.Product-Image').addClass("scrolled");
        } else {
          $('.Product-Image').removeClass("scrolled");
        }
        
        last_scroll = $(window).scrollTop();
      });



    } else {
      /*$(document).on('scroll', function() {
        if ($(window).scrollTop() > 150) {
          $('.Product-background').addClass("scrolled");
        } else {
          $('.Product-background').removeClass("scrolled");
        }
      });*/
    }
  }
});

$(document).ready(function() {

  setTimeout(function() {
    $('[vd-src]').each(function() {
      var s = $(this).attr("vd-src");
      //$(this).attr("src", s);
    });
  }, 5000);
  $(".__pf .pf-7d59cc86").on('click', function(event) {
    event.preventDefault();
    zE.showIPMWidget();
  });
  $(".open-reviews").on('click', function() {
    $("#netreviewsWidgetNum24432widget02avImage").click();
  });
  
  $('.slidecarthq__reassurances').flickity({
    contain: true,
    autoPlay: 3100,
	pauseAutoPlayOnHover: true,
    wrapAround: true
  });
  $(".Sidecart__slideshow-upsells").flickity({
    contain: true,
    pageDots: false,
    wrapAround: true
  });
  $(".CartUpsell__next").on('click', function() {
    $(".Sidecart__upsells .flickity-button.next").click();
  });
  $(".CartUpsell__prev").on('click', function() {
    $(".Sidecart__upsells .flickity-button.previous").click();
  });
  $(".Header__open-menu").on("click", function() {
    $(".DrawerMenu").fadeIn();
  });
  $(".Header__close-menu").on("click", function() {
    $(".DrawerMenu").fadeOut();
  });
  $("[data-cara-open]").on('click', function() {
    var item = $(this).attr("data-cara-open");
    $('[data-cara]').hide();
    $('[data-cara="' + item + '"]').show();
    $('[data-cara-open]').removeClass("actif");
    $(this).addClass("actif");

    var position = $(this).position().left;
    const el = document.querySelector('.Product-caracteristics__thumb');
    // set scroll position in px
    if (item == "size") {
      el.scrollLeft = 0;
    } else {
      el.scrollLeft = position;
    }
  });
});


var navbarHeight = 90;
function offsetAnchor() {
  if (window.location.hash.length !== 0) {
    window.scrollTo(window.scrollX, window.scrollY - navbarHeight );
  }
}

$(document).on('click', 'a[href^="#"]', function(event) {
  window.setTimeout(function() {
    offsetAnchor();
  }, 0);
});

window.setTimeout(offsetAnchor, 0);

function isElementInViewport (el) {

    // Special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
    }

    var rect = el.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
        rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
    );
}


function onVisibilityChange(el, callback) {
    var old_visible;
    return function () {
        var visible = isElementInViewport(el);
        if (visible != old_visible) {
            old_visible = visible;
            if (typeof callback == 'function') {
                callback();
            }
        }
    }
}

var handler;

$(document).ready(function() {

  if (window.location.href.indexOf("products") > -1 && $(".custom-video-iframe-content").length > 0) {
    handler = onVisibilityChange($(".custom-video-iframe-content"), function() {
      if (isElementInViewport($(".custom-video-iframe-content")) && !($(".custom-video-iframe-content").attr("src"))) {
        var t = $(".custom-video-iframe-content").attr("vd-src");
        $(".custom-video-iframe-content").attr("src", t);
      }
    });
  }
  $(window).on('DOMContentLoaded load resize scroll', handler);
  var t = $(".custom-video-iframe-content").attr("vd-src");
  $(".custom-video-iframe-content").attr("src", t);
});

// jQuery

$(document).ready(function() {
  
 
  $('[href="/#section-1601399558347"]').on("click", function(event) {
    event.preventDefault();
    if ($(window).width() < 1024) {
      $(".nav-mobile-close").click();
    }
    $("html, body").animate({ scrollTop: $("#section-1601399558347").offset().top }, 1000);
  });
  
  setTimeout(function() {
    $(".product-tab-content p:first-child").after("<span render-text> <strong>Lire la suite</strong></span>");
    var click = false;
    $("[render-text]").on('click', function() {
      click = click ? false : true;
      $(".product-tab-content p, .product-tab-content span, .product-tab-content ul, .product-tab-content li, .product-tab-content").toggleClass("actif");
      if (click == true) {
        $("[render-text] strong").html("Réduire"); 
      } else {
        $("[render-text] strong").html("Lire la suite"); 
      }
    });
  }, 2000);

  $(".intellisolar-form input, .intellisolar-form select").focusin(function() {
    if ($(this).val().length == 0) {
      $(this).prev().toggleClass("actif");
    }
  });
  $(".intellisolar-form input, .intellisolar-form select").focusout(function() {
    if ($(this).val().length == 0) {
      $(this).prev().toggleClass("actif");
    }
  });
  
  $('#play').on('click', function(e) {
  e.preventDefault();
  //$(this).next().attr("src", $(this).next().attr("src") + "?autoplay=1;rel=0;modestbranding=1;controls=0&amp;title=&amp;controls=0");
  $('#section-product-aio-video .play-container').hide();
});
  
  let vh = window.innerHeight * 0.01;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  $(window).resize(function() {
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    var height;
    var last_height = 0;
    $(".template-product .features-inline__text p").each(function() {
      var p_height = $(this).height();
      if (p_height > last_height) {
        height = p_height;
      }
    });
    $(".template-product .features-inline__text p").height(height);


    var minHeightContainer = $('.index-products-animation-keys').height() + $('.index-products__grid').height() + $('.index-products-animation').height() + 200;
    document.documentElement.style.setProperty('--minHeightIndexContainer', `${minHeightContainer}px`); 

    document.documentElement.style.setProperty('--headerHeight', $('#section-v2-header').outerHeight(true) + "px");
    document.documentElement.style.setProperty('--headerBannerHeight', $('.Product-header__banner').outerHeight(true) + "px");

    
  });
  
  
  var height;
  var last_height = 0;
  $(".template-product .features-inline__text p").each(function() {
    var p_height = $(this).height();
    if (p_height > last_height) {
      height = p_height;
    }
  });

  $(".template-product .features-inline__text p").height(height);

  
  

  if ($(".template-index").length > 100) {
    get_reviews(0);
    $(".nb_reviews").html(reviews.length);

    $("[reviews-previous] svg").addClass("disabled");

    var real_reviews_index = 0;

    var nb_page = Math.round(reviews.length / 3);

    $("[reviews-previous] svg").on('click', function() {
      $("[reviews-next] svg").removeClass("disabled");
      if (real_reviews_index != 0) {
        real_reviews_index -= 3;
        get_reviews(real_reviews_index);
        if (real_reviews_index == 0) {
          $(this).addClass("disabled");
        }
      }
    });

    $("[reviews-next] svg").on('click', function() {
      $("[reviews-previous] svg").removeClass("disabled");
      if (real_reviews_index < nb_page) {
        real_reviews_index += 3;
        get_reviews(real_reviews_index);

        if (real_reviews_index >= nb_page) {
          $(this).addClass("disabled");
        }
      }
    });

  }
  
  if ($(".template-cart").length > 0) {
    setTimeout(function() {
      $(".ls-add-to-cart.ls-button").html('<svg width="11" height="4" viewBox="0 0 11 4" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.41761 3.84798C7.60428 3.35331 7.83294 2.92864 8.10361 2.57398H0.599609V1.42598H8.10361C7.84228 1.07131 7.61828 0.646644 7.43161 0.151978H8.49561C9.07428 0.833311 9.70894 1.35131 10.3996 1.70598V2.30798C9.70894 2.64398 9.07428 3.15731 8.49561 3.84798H7.41761Z" fill="#49474B"/></svg>' + "AJOUTER AU PANIER")
      $("limespot-box").fadeIn();
    }, 1500);
  }


  var location = window.location.href;
  if (location.indexOf("pages/toiture-solaire") > -1 || location.indexOf("pages/histoire") > -1 || location.indexOf("pages/toitures-solaires") > -1 || location.indexOf("pages/devenir-vendeur-installateur-sur-sunology") > -1 || location.indexOf("pages/contact") > -1) {
    if (!(location.indexOf("pages/contact") > -1)) {
      $('[data-pf-type="Button"]').addClass("button").addClass("button--primary");
      $('[data-pf-type="Button"]').prepend('<svg width="11" height="4" viewBox="0 0 11 4" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.41761 3.84798C7.60428 3.35331 7.83294 2.92864 8.10361 2.57398H0.599609V1.42598H8.10361C7.84228 1.07131 7.61828 0.646644 7.43161 0.151978H8.49561C9.07428 0.833311 9.70894 1.35131 10.3996 1.70598V2.30798C9.70894 2.64398 9.07428 3.15731 8.49561 3.84798H7.41761Z" fill="#49474B"/></svg>'); 
    } else {
      $('[data-pf-type="Button"]').each(function() {
        if ($(this).find('span').html() == "CONSULTER LA FAQ" || $(this).find('span').html() == "POSTULEZ MAINTENANT" || $(this).find('span').html() == "POSTULER MAINTENANT") {
          $(this).addClass("button").addClass("button--primary");
          $(this).prepend('<svg width="11" height="4" viewBox="0 0 11 4" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.41761 3.84798C7.60428 3.35331 7.83294 2.92864 8.10361 2.57398H0.599609V1.42598H8.10361C7.84228 1.07131 7.61828 0.646644 7.43161 0.151978H8.49561C9.07428 0.833311 9.70894 1.35131 10.3996 1.70598V2.30798C9.70894 2.64398 9.07428 3.15731 8.49561 3.84798H7.41761Z" fill="#49474B"/></svg>'); 
        }
      });
    }
  }
});

$(window).scroll(function() {
  if ($(window).scrollTop() > 50) {
    $("#netreviewsWidgetNum24432widget02av").addClass("netreviews-scrolled"); 
  } else if ($(window).scrollTop() > $(window).height() - 360) {
    $("#netreviewsWidgetNum24432widget02av").addClass("netreviews-scrolled"); 
  } else {
    $("#netreviewsWidgetNum24432widget02av").removeClass("netreviews-scrolled"); 
  }
});


var idx = 0;

function get_reviews(index) {
  var index1 = 0;
  var index2 = 0;
  idx = 0;
  
  $(".reviews-loading").show();
  
  $(".spr-icon.spr-icon-star-empty").hide();
  $(".spr-icon.spr-icon-star").show();

  
  for (var i = index;i < reviews.length;i++) {
    if (idx < 3) {
      $('[reviews-index="' + index1 + '"]' + ' .review-time').html(reviews[i].created_at.split(" ")[0]); 
      $('[reviews-index="' + index1 + '"]' + " .review-body").html(reviews[i].body); 
      $('[reviews-index="' + index1 + '"]' + " .review-name").html(reviews[i].author); 
      $('[reviews-index="' + index1 + '"]' + " [review-rate]").html(reviews[i].rating);
      $('[reviews-index="' + index1 + '"][review-handle]').attr("review-handle", reviews[i].product_handle);

      var stars_to_hide = 5 - reviews[i].rating + 1;
      for (var j = 1;j < stars_to_hide;j++) {

        $('[reviews-index="' + index1 + '"] .spr-icon-star[v-index="' + j + '"]').hide();
        $('[reviews-index="' + index1 + '"] .spr-icon-star-empty[v-index="' + j + '"]').show();
      }

      if (reviews[i].product_handle != "sunology-intellisolar") {
        $.get("/products/" + reviews[i].product_handle + ".js" , function(responseData) {
          responseData = JSON.parse(responseData);
          $('[review-handle="' + responseData.handle + '"] [review-product-link]').html(responseData.title); 
          $('[review-handle="' + responseData.handle + '"] [review-product-link]').attr("href", "/products/" + responseData.handle);
          index2 += 1;
          if (index2 == 3) {
            $(".reviews-loading").hide();
          }
        });
      } else {
        $('[reviews-index="' + index1 + '"] [review-product-link]').html("Sunology Intellisolar"); 
        $('[reviews-index="' + index1 + '"] [review-product-link]').attr("href", "/products/" + reviews[i].product_handle);
        index2 += 1;
      }
      idx += 1;
    }
    index1 += 1;
  } 
}

var scrollbar_instance = null;

function initializeInstance_scrollbar(classname) {
  var scrollbar_instance = OverlayScrollbars(document.querySelectorAll(classname), {
    className: "os-theme-thin-dark",
  });
  $(classname + " .ls-add-to-cart.ls-button").on('click', function() {
    $(this).focus();
  });
  $(classname + " .ls-add-to-cart.ls-button").html('<svg width="11" height="4" viewBox="0 0 11 4" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.41761 3.84798C7.60428 3.35331 7.83294 2.92864 8.10361 2.57398H0.599609V1.42598H8.10361C7.84228 1.07131 7.61828 0.646644 7.43161 0.151978H8.49561C9.07428 0.833311 9.70894 1.35131 10.3996 1.70598V2.30798C9.70894 2.64398 9.07428 3.15731 8.49561 3.84798H7.41761Z" fill="#49474B"/></svg>' + "AJOUTER AU PANIER");
  setTimeout(function() {
    const slider = document.querySelector(classname + ' .os-viewport');
    let isDown = false;
    let startX;
    let scrollLeft;

    if (slider) {
      slider.addEventListener('mousedown', (e) => {
        isDown = true;
        slider.classList.add('active');
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });
      slider.addEventListener('mouseleave', () => {
                              isDown = false;
                              slider.classList.remove('active');
    });
    slider.addEventListener('mouseup', () => {
                            isDown = false;
                            slider.classList.remove('active');
  });
  slider.addEventListener('mousemove', (e) => {
    if(!isDown) return;
    //e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 1.1; //scroll-fast
    slider.scrollLeft = scrollLeft - walk;
  });
  $(classname.split(" ")[0] + " .collectionGrid-row__arrows--left, " + classname.split(" ")[0] + " .collectionGrid-row__arrows--right").on('click', function() {
    $(this).toggleClass("actif");
    if ($(this).hasClass("collectionGrid-row__arrows--left")) {
      var left = $(classname + " .os-viewport").scrollLeft() - 500;
      if (left < 0) {
        left = 0;
      }
      scrollbar_instance.scroll({ x : left }, 200);
    } else {
      var right = $(classname + " .os-viewport").scrollLeft() + 500;
      if (right > $(classname + " .os-viewport").width()) {
        left = $(classname + " .os-viewport").width();
      }
      scrollbar_instance.scroll({ x : right }, 200);
    }
    $(this).toggleClass("actif");

  });

  $(classname.split(" ")[0] + " [href]").each(function() {
    $(this).attr("hrefbis", $(this).attr("href"));
    $(this).removeAttr("href");
    var scroll_left = $(classname.split(" ")[0] + " .os-viewport").scrollLeft();
    var scroll_left_mousedown = 0;
    var relX = 0;
    var relY = 0;
    $(this).mouseup(function(event) {

      //event.preventDefault();
      var relX1 = event.pageX - $(this).offset().left;
      var relY1 = event.pageY - $(this).offset().top;
      /*if (scroll_left_mousedown == $(".os-viewport").scrollLeft()) {
      window.location.href = $(this).attr("hrefbis");
    }*/
      if (relX1 == relX && relY1 == relY) {
        window.location.href = $(this).attr("hrefbis");
      }
    })
    .mousedown(function(event) {
      //event.preventDefault();
      relX = event.pageX - $(this).offset().left;
      relY = event.pageY - $(this).offset().top;
    });
    if ($(classname.split(" ")[0] + " .os-scrollbar-horizontal.os-scrollbar-unusable").length < 1) {
      $(classname.split(" ")[0] + " .slide-left").attr("style", "opacity: 1 !important;");
      $(classname.split(" ")[0] + " .slide-right").attr("style", "opacity: 1 !important;");
    }
  });      
}
}, 1000);
}

document.addEventListener("DOMContentLoaded", function() {
  //The first argument are the elements to which the plugin shall be initialized
  //The second argument has to be at least a empty object or a object with your desired options

  if (!($('body').hasClass("template-product"))) {
    
    var index = 1;
    $(".shopify-section.shopify-section--featured-collection").each(function() {
      initializeInstance_scrollbar("#" + $(this).attr("id") + " .collectionGrid-row");
      index++;
    });
          
  } 
  
  
  var is_passed = [];
  var _pass = false;
  var ps = false;
  $('body').on('DOMNodeInserted', 'limespot-box', function () {
    if (_pass == false){
      var scrollbar_instance = null;
      setTimeout(function() {

        var index = 0;
        $("[data-placement-order]").each(function() {
          if (!($(this).attr("data-placement-order") in is_passed)) {
            var attr = $(this).attr("data-box-type");
            initializeInstance_scrollbar('[data-box-type="' + attr + '"] .collectionGrid-row');
            is_passed.push($(this).attr("data-placement-order"));
            ps = true;
          }
        });
        
        if (ps == false) {
          setTimeout(function() {
            $("[data-placement-order]").each(function() {
              if (!($(this).attr("data-placement-order") in is_passed)) {
                var attr = $(this).attr("data-box-type");
                initializeInstance_scrollbar('[data-box-type="' + attr + '"] .collectionGrid-row');
                is_passed.push($(this).attr("data-placement-order"));
                ps = true;
              }
            });
            
          }, 2000);
        }

      }, 3000);
      _pass = true;
    }
  });
 
  
 
});

function forceProRedirect() {
  $('[name="checkout_url"]').attr("value", "/collections/pro"); 
  setTimeout(forceProRedirect, 500);
}


$(document).ready(function() {

  if ($('[name="checkout_url2"]') && $('[name="checkout_url2"]').length > 0) {
    forceProRedirect();
  }


  $('[to-step]').on('click', function() {
    var to_step = $(this).attr("to-step");
    var current_step = $(this).closest('[stepform]').attr("stepform");
    var form_error = false;
    if (!($(this).hasClass("previous-btn"))) {
      $('[stepform="' + current_step + '"] .form__form--input').each(function () {
        if ($(this).val().length == 0) {
          $(this).addClass("input--error");
          form_error = true;
        } else {
          $(this).removeClass("input--error");
        }
      });
    }
    if (!form_error) {
      if (current_step < 4 || $(this).hasClass("previous-btn")) {
        $('[stepform').hide();
        $('[stepform="' + to_step + '"]').fadeIn();
      }
    }
  });
  $("#submitButton").on("click", function(event) {
    event.preventDefault();
    if ($("#form__form--radioRgpd:checked").length == 1) {
      $("#contact_form").submit();
    } else {
      $(".form__form--radioRgpdLabel").addClass("label--error");
    }
  });
  $(".custom-header__toogleMenu").on("click", function() {
    $(".hs-menu-drawer").removeClass("inactive");
  });
  $(".hs-close-menu").on("click", function() {
    $(".hs-menu-drawer").addClass("inactive");
  });

  var last_h = 0;

  $('.steps-detail .steps-detail__item p').each(function() {
    if (last_h < $(this).height()) {
      last_h = $(this).height();
    }
  });
  $('.steps-detail .steps-detail__item p').height(last_h);

  $(".faq .faq__item").on('click', function() {
    $(this).toggleClass("actif");
  });

  /** *********************** **/
  /**  Variant selector event **/
  /** *********************** **/

  if ($('.template-product') && $(".Product-selector").length > 0) {

    var specifiedElement1 = document.querySelector('.kit-selector .Product-selector');

    document.addEventListener('click', function(event) {
      var isClickInside = specifiedElement1.contains(event.target);

      if (!isClickInside) {
        $(".kit-selector .Product-selector__list").removeClass("actif");
      }
    });
  }
  
  if ($('.play-configurator').length == 0) {
    $('[data-variant-id]').on('click', function() {
      if($(this).parents('#slidecarthq').length) {
        return false;
      }

      var variant_id = $(this).attr("data-variant-id");

      $('.kit-selector-container-hover').removeClass("actif");
      $('[data-variant-id='+ variant_id +']').addClass("actif");

      $('.Product-form__block select').val(variant_id).change();
      var variant_title = $(this).attr("data-title");

      if (variant_title && variant_title.length > 0) {
        $('[data-current-variant-title]').html(variant_title);
      } else {
        $('[data-current-variant-title]').html($(this).html());
      }
      $(".Product-selector__list").removeClass("actif");
      var price = $(this).attr("data-variant-price")
          pricecompare = $(this).attr("data-variant-pricecompare");
      reloadAlma(price);
      var price_formated = price / 100 + "€",
          pricecompare_formated = pricecompare / 100 + "€";
      
      var payable_4, payable_10, alma_multiplier = 1.0569;
	  payable_4 = (price / 400.00).toFixed(2) + "€/mois";
      payable_10 = (price / 1000.00 * alma_multiplier).toFixed(2) + "€/mois"; 
      $(".data-alma-4-price").html(payable_4);
	  $(".data-alma-10-price").html(payable_10);
      
      $(".product-normal-price").html(price_formated);
      $(".product-compare-price").html(pricecompare_formated);
    });
  }

  $(".add-to-cart").on('click', function() {
    $('[data-number-kit="1"]').click();
    $(".kit-selector .Product-form__submit").click();
  });

  if ($('.template-product') && $('.template-product').length > 0) {
    //setTimeout(() => {reloadAlma(parseInt($(".product-normal-price").html().replace("€", "")) * 100)}, 500);
  }


  // Crisp chatbox event
  $('[open-crisp-chat]').on("click", function() {
    $crisp.push(['do', 'chat:open']);
    if ($(".play-configurator").length > 0) {
      $('.crisp-client .cc-kv6t').attr("style", "z-index: 99999999 !important;opacity: 1 !important;");
    } 
  });

  // Simulator events
  var in_modal = false;

  $('.Product-simulator').on('click', function() {
    showSimulator();
  });

  $("[data-close-modal]").on('click', function() {
    $("#modalIntellisolar").hide();
    $(".modal-backdrop").removeClass("actif");
    in_modal = false;
    $(".modal-body").show();
    $(".intellisolar-variants, .intellisolar-defs").hide();
    $("body").removeClass("disabled");
  });

  // Click out of modal --> close it

  if ($(".Product-simulator") && $(".Product-simulator").length > 0) {
    var specifiedElement3 = document.querySelector('.modal-content-custom');
    var specifiedElement4 = document.querySelector('.Product-simulator');

    document.addEventListener('click', function(event) {
      var isClickInside = specifiedElement3.contains(event.target);
      var isClickInsideSim = specifiedElement4.contains(event.target);

      if (!isClickInside && in_modal && !isClickInsideSim) {
        $("#modalIntellisolar").hide();
        $(".modal-backdrop").removeClass("actif");
        $(".modal-body").show();
        $(".intellisolar-variants, .intellisolar-defs").hide();
        $("body").removeClass("disabled");
      }
    });
  }
});

function showSimulator() {
  $("#modalIntellisolar").show();
  $(".modal-backdrop").addClass("actif");
  $("body").addClass("disabled");
  setTimeout(function() {
    in_modal = true;
  }, 1000);
}

function reloadAlma(price) {
  var widgets = Alma.Widgets.initialize(
    '11kItpUN8KrAkdDNIuG2A2w8ioCq1q4xI6',
    Alma.ApiMode.LIVE,
  );

    widgets.add(Alma.Widgets.PaymentPlans, {
      container: '#alma-badge',
      purchaseAmount: price,
      plans: [
        { installmentsCount: 4, minAmount: 64900, maxAmount: 300000 },
        { installmentsCount: 10, minAmount: 64900, maxAmount: 300000 }
      ]
    });

    

  widgets.render();
}



/*********
 * Configurator 
 ********/

 var intelConfigurator = {
   init: function() {

   },
   start: function() {
      window.location.href = "/pages/configurateur-sunology-play";
   },
   goCheckout: function() {
      window.location.href = "/checkout";
   }
 }